import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { pathOrCreatorPoints } = appStoreLenses

export default pathOrCreatorPoints(0)
